<template>
<div class="col backgroundForm">
    <div class="col col-md-10 offset-md-1">
        <h3 clas="col" align="center">Novedades/Reportes Importantes </h3>
        <h6 align="right"></h6>
        
        <nav>
            <div class="nav nav-pills" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-init-traffic" data-toggle="tab" href="#reg-nov" role="tab" aria-controls="nav-home" aria-selected="true">Registro</a>
                <a class="nav-item nav-link" id="nav-init-traffic" data-toggle="tab" href="#list-nov" role="tab" aria-controls="nav-home" aria-selected="true">Listado</a>    
            </div>
        </nav>
        
        <div class="tab-content" id="nav-tabContent">
            <br>            
            <div class="tab-pane fade show active"  id="reg-nov" role="tabpanel" aria-labelledby="nav-home-tab">
                <VueEditor v-model="novedades_reg" :editor-toolbar="customToolbar" />
        
                <br><br>
                <button class="btn btn-outline-success col-12 col-md-4 offset-md-4" @click="mRegisterNovedad" :disabled="animate_register"> <font-awesome-icon icon="save"  :bounce="animate_register" /> Registrar</button>
            </div>
            <div class="tab-pane fade"  id="list-nov" role="tabpanel" aria-labelledby="nav-home-tab">
                <div class="input-group mb-3 col-12 col-md-6 offset-md-3">
                    <input type="date" class="form-control" placeholder="Fecha de Registros" aria-describedby="basic-addon2" v-model="fecha_novedades">
                    <div class="input-group-append">
                        <button class="btn btn-outline-success" type="button" @click="mLlamaNovedades('cf')">A la Fecha</button>
                    </div>
                    <div class="input-group-append">
                        <button class="btn btn-outline-info" type="button" @click="mLlamaNovedades('sf')">Ultimo Registro</button>
                    </div>
                    <div class="input-group-append">
                        <button class="btn btn-outline-danger" type="button" @click="mLlamaNovedades('na')">No Atendidos</button>
                    </div>
                </div>

                <br><br>
                <!-- aqui listamos los registros -->
                 <div class="table-responsive" id="printTable">
                    <table class="table table-sm table-hover" v-if="dts_novedad.length>0">
                        <thead>
                            <tr style="font-size: 12px;">
                                <th align="center" class="align-middle" >#</th>
                                <th align="center" class="align-middle" >FECHA/HORA REGISTRO</th>
                                <th align="center" class="align-middle" >NOVEDAD</th>
                                <th align="center" class="align-middle" >ATENDIDO</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dn, index) in dts_novedad" :key="dn.id" style="font-size: 12px;">
                                <td class="align-middle">{{ index+1 }}</td>
                                <td class="align-middle">{{ $dateMilitary2(dn.fecha_reg) }}</td>
                                <td><div v-html="dn.novedades"></div></td>
                                <td align="center" class="align-middle" :class="dn.atendido ==='N' ? 'alert alert-danger':'alert alert-success'">{{ dn.atendido ==='N' ? 'NO': 'SI' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div><!-- aqui termina el div de la tabla de las novedades -->
            </div>
        </div>
        
    
    </div>
</div>
</template>
<script type="ts">
import Vue from 'vue';
import axios from 'axios'
const qs= require('qs');

import { VueEditor } from "vue2-editor";
import { computed } from 'vue';

// customToolbar: [
//             ["bold", "italic", "underline"],
//             [{ list: "ordered" }, { list: "bullet" }],
//             ["image", "code-block"]
//         ],

export default{
    name:'novedades',
    data(){
        return{
            customToolbar: [
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["code-block"]
            ],
            novedades_reg:'',
            animate_register:false,
            dts_novedad:[],
            fecha_novedades:''
        }
    },
    mounted() {
        this.mCargaInicial();
    },
    methods: {
        mCargaInicial(){
            this.fecha_novedades=this.$dateActually();
        },
        async mLlamaNovedades(tipo='cf'){
            try {
                this.dts_novedad=[];
                // aqui se llama al servidor para obtener la informacion de las novedades registradas
                let busca_novedades=await axios.get(`searchNovedades/${tipo}/${this.cDtsUser.portId}/${this.fecha_novedades}?api_token=${Vue.auth.getToken()}`);
                console.log(busca_novedades);
                if(busca_novedades.data[0].status){
                    this.dts_novedad=busca_novedades.data[0].novedades;
                }else{
                    toastr.warning(`No se ha encontrado ningún registro`);
                }
            } catch (error) {
                console.log(error);
            }
        },
        async mRegisterNovedad(){
            try {
                if(this.novedades_reg!=='' &&this.novedades_reg.length>0){
                    this.animate_register=true;
                    let aux_novedad={
                        novedad:this.novedades_reg,
                        capitania:this.cDtsUser.portId
                    }
                    let aux_register=await axios.post(`registerNovedad?api_token=${Vue.auth.getToken()}`,  qs.stringify(aux_novedad));
                    if(aux_register.data.status){
                        toastr.success(`${aux_register.data.response}`);
                        this.novedades_reg='';
                    }else{
                        toastr.danger(`${aux_register.data.response}`);
                    }
                    setTimeout(()=>{
                        this.animate_register=false;
                    }, 1000)
                    console.log(this.novedades_reg);
                }else{
                    toastr.warning('Debe señalar un dato de novedad para su registro');
                }
            } catch (error) {
                console.log(error);
            }
        }
    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        },
    },
    components: { VueEditor }
}

</script>
<style lang="css">
/* @import "~vue2-editor/dist/vue2-editor.css"; */

/* Import the Quill styles you want 
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css'; */
</style>


// WEBPACK FOOTER //
// src/components/captain/Novedades.vue